import { DateTime } from 'typescript-dotnet-es6/System/Time/DateTime'
import { DatePipe } from '@angular/common'

export function AddDaysToDate(date:DateTime,  days:number):DateTime{
    //this fixes an issue with DateTime.AddDays() where a switch to or from daylight savings time is in the span of days AddDays() spans

    //this is solved for our case where we are just working with dates by using .date to pull date set to midnight
    //and adding the days and then adding two hours to make sure we've entered the next day and resetting to midnight for that day
  const setDate = date.date;
  return setDate.addDays(days).addHours(2).date;
}

export function ConvertToDateTimeString(date:Date):string{
  //2017-06-10T00:00:00 is the format we want
  var output = '';
  output += date.getFullYear() + '-';
  var month = date.getMonth() + 1;
  output += (month<10?'0'+month:month) + '-';
  var day = date.getDate();
  output += (day<10?'0'+day:day) + 'T00:00:00';
  return output;
}

export function ConvertBlankDate(date: Date, dateFormat:string = 'medium', dfault?:string ) {
  if (date && date.valueOf() != 0) {
    let obj = new DatePipe("en-EN");
    return obj.transform(date, dateFormat);
  }
  if (dfault) {
    return dfault;
  }
  return "";
}
